import inView from './viewport';
import {annotate} from '../vendors/rough-notation.min';

export default function handleHighlights () {
    const headings = document.querySelectorAll('h1, h2, h3, h4');
    const links = document.querySelectorAll('.list-item .read-more, .wysiwyg_block a, footer a, .post-meta .read-more, [itemprop="description"] a');
    const highlightConfig = {
        type: 'highlight',
        color: '#FFC22A',
        iterations: 2,
        multiline: true
    };
    const bracketsConfig = {
        type: 'underline',
        color: '#FFC22A',
        iterations: 2,
        padding: 3,
        strokeWidth: 2
    };
    const parseHeadings = () => {
        headings.forEach((heading) => {
            const spanElement = document.createElement('span');

            while (heading.firstChild) {
                spanElement.appendChild(heading.firstChild);
            }
            heading.appendChild(spanElement);

            const innerSpan = heading.querySelector('span');
            const mark = annotate(innerSpan, highlightConfig);

            heading.setAttribute('data-highlighted', '');
            mark.show();
        });
    };
    const parseLinks = () => {
        links.forEach((link) => {
            const mark = annotate(link, bracketsConfig);

            link.setAttribute('data-outlined', '');
            mark.show();
        });
    };

    if (headings.length) {
        setTimeout(() => {
            parseHeadings();
        }, 1000);
    }

    if (links.length) {
        setTimeout(() => {
            parseLinks();
        }, 1000);
    }

    inView();
}
